import * as React from 'react';
import Heading from '../../components/heading/Heading';
import TypographyStyleGuide from './typography-style-guide/TypographyStyleGuide';
import IconsStyleGuide from './icons-style-guide/IconsStyleGuide';

const StyleGuide: React.FC<any> = () => (
  <div className="container">
    <div className="mt-3">
      <Heading size="h1">Components - Style Guide</Heading>
    </div>
    <br />
    <TypographyStyleGuide />
    <br />
    <IconsStyleGuide />
  </div>
);

export default StyleGuide;
